import { get } from 'lodash';

export const quickBooksIsConnected = state => get(state, 'reports.quickBooks.isConnected', false);
export const quickBooksAuthorizationUrl = state => get(state, 'reports.quickBooks.authUrl', null);
export const quickBooksBankAccountTypes = state => get(state, 'reports.quickBooks.bankAccountTypes', []);
export const quickBooksBankDepositAccounts = state => get(state, 'reports.quickBooks.depositAccounts', []);
export const quickBooksAccountMap = state => get(state, 'reports.quickBooks.accountMap', null);
